'use client';
import useTranslationHook from '@/hook/use-translation-client.hook';
import { CheckCircleGray } from 'public/Images';
import React from 'react';
import Typography from '../typography/typography.component';
import myImageLoader from '@/image.local.loader';

const CarIncludeBadge = ({ text }: { text: string }) => {
    const { t } = useTranslationHook();
    return (
        <div className="flex items-center justify-end gap-1 px-1.5 py-0.5 rounded-md bg-gray-50 whitespace-nowrap">
            <img
                src={myImageLoader({
                    src: CheckCircleGray.src,
                    width: 20,
                    height: 20,
                    quality: 100,
                })}
                alt="Included"
                width={10}
                height={10}
            />
            <Typography
                variant="caption2"
                className="text-gray-600 whitespace-nowrap"
            >
                {t(text)}
            </Typography>
        </div>
    );
};

export default CarIncludeBadge;
